/**
 * InputAdornment
 * This is a wrapping component for some defaults around Material-UI's InputAdornment
 */
import { CheckCircleIcon, CloseIcon, ExclamationCircleIcon } from '../Icons';
import { IconButton, InputAdornment } from '@material-ui/core';
import React from 'react';
const TextFieldAdornment = props => {
    const { onClear: handleClear, error, value } = props;
    // onMouseDown is required for the IconButton because we're swapping out the adornment
    // when the element is focused and when it is not, a click on the IconButton would move focus
    // to the button instead of the TextField which would then hide the IconButton and prevent the
    // Click even from triggering
    return (React.createElement(InputAdornment, { position: "end" },
        React.createElement("span", { className: "adornment-focused" }, handleClear && (React.createElement(IconButton, { edge: "end", "aria-label": "clear input", onMouseDown: handleClear },
            React.createElement(CloseIcon, null)))),
        React.createElement("span", { className: "adornment-unfocused" },
            error && React.createElement(ExclamationCircleIcon, { color: "error" }),
            !error && !!value && React.createElement(CheckCircleIcon, { color: "action" }))));
};
export default TextFieldAdornment;
//# sourceMappingURL=TextFieldAdornment.js.map